<button #defaultOriginDialogButtons="voxelOverlayOrigin" voxelOverlayOrigin class="no-visible"></button>

<span *ngIf="componentStart">
    {{linkSetting?.before_text}}
    <button voxelButtonAction (click)="onShowModal()">{{linkSetting?.link_text}}</button>
    {{linkSetting?.after_text}}
</span>

<span *ngIf="!componentStart" class="voxel-col-12">
    <button voxelButtonAction (click)="onShowModal()">{{CONTENT_BOUNDS?.caption_link_solicitation_data.label}}</button>
</span>

<voxel-modal id="modal-a" modalAriaLabelledby="types-modal-title" [modalOrigin]="defaultOriginDialogButtons"
    [modalIsOpen]="modalAShow" [buttonLabels]="{ primary: CONTENT_BOUNDS?.modals?.types_solicitation?.button_label }"
    (modalClose)="onCloseModal($event)" *ngIf="CONTENT_BOUNDS" style="height: 100%;">
    <h3 id="types-modal-title">{{CONTENT_BOUNDS?.modals?.types_solicitation?.title}}</h3>
    <div class="voxel-row-4 voxel-border voxel-border-radius-layout-01 voxel-border-small search" [formGroup]="form">
        <div class="voxel-col-3 filter">

            <voxel-icon>busca_outline</voxel-icon>

            <input type="text" voxelInput voxelAutocomplete #includesFilterInputState="voxelAutocomplete" />

            <voxel-autocomplete #autocomplete [input]="includesFilterInputState" filterMode="includes"
                (optionSelected)="optionSelected($event)">
                <voxel-option *ngFor="let item of solicitationTypesFilter || []" [value]="item">
                    {{ item?.name }}
                </voxel-option>
            </voxel-autocomplete>
        </div>
        <div class="voxel-col-1 actions-filter">
            <button id="cln" voxelButtonContextual buttonStyle="secondary" (click)="cleanFilter()"
                [textContent]="CONTENT_BOUNDS?.modals.types_solicitation?.clearBtn" class="voxel-col-6"></button>
            <!--<button id="sch" voxelButtonContextual buttonStyle="secondary" (click)="setList($event)"
                [textContent]="CONTENT_BOUNDS?.modals.types_solicitation?.searchBtn" class="voxel-col-5" ></button>-->
        </div>
    </div>
    <div class="voxel-modal__content_search">
        <p class="voxel-pv-5" [textContent]="CONTENT_BOUNDS?.modals?.types_solicitation?.caption"></p>

        <div class="loading">
            <voxel-loading-circle [hideLoading]="false" *ngIf="loading"
            [loadingTitle]="CONTENT_BOUNDS?.load_text"></voxel-loading-circle>
        </div>

        <voxel-accordion *ngFor="let type of solicitationTypesList" [accordionTitle]="textDescriptionType(type) | async"
            style="height: 600px;">
            <ng-container class="content">
                <voxel-list>
                    <li voxelListSimple *ngFor="let subtype of type.subtypes">
                        <voxel-list-text [textContent]="subtype.name"></voxel-list-text>
                        <voxel-list-descr *ngIf="subtype?.description">{{subtype.description}}</voxel-list-descr>
                    </li>
                </voxel-list>
            </ng-container>
        </voxel-accordion>
    </div>

    <div voxelModalFooter>
        <div class="voxel-row">
            <button voxelButton (click)="onCloseModal($event)"
                class="voxel-col-12 voxel-col-offset-xs-2 voxel-col-xs-2 voxel-col-offset-sm-3 voxel-col-sm-4 voxel-col-offset-md-5 voxel-col-md-4">
                {{CONTENT_BOUNDS?.modals?.types_solicitation?.button_label}}
            </button>
        </div>
    </div>

</voxel-modal>